<template>
  <v-card class="myprofile-popup phone-numbers-edit">
    <v-card-title>
      {{ memberProfileConstants.CONTACT_INFORMATION.EDIT_MY_PHONE_NUMBER }}
      <i class="fas fa-times" data-qe-id="close_dialog_btn" @click="cancel(false)"></i>
    </v-card-title>
    <v-card-text ref="phoneNumbersDailogid" v-model="modelPhoneNumber.isDialog" class="inner-scrollbar">
      <v-form v-model="valid" class="contact-info__full-width" lazy-validation>
        <v-layout class="title-block" row wrap>
          <v-flex xs1></v-flex>
          <v-flex xs2></v-flex>
          <v-flex xs2></v-flex>
          <v-flex xs1></v-flex>
          <v-flex class="form-title" pr-2 xs2>{{ memberProfileConstants.CONTACT_INFORMATION.DISPLAY_ON_MY_PROFILE }}
          </v-flex>
          <v-flex class="form-title" pr-2 xs2>
            {{ memberProfileConstants.CONTACT_INFORMATION.MEMBERS_CAN_TEXT_ME_HERE }}
          </v-flex>
          <v-flex :class="isYPOPrimaryErrorMessage ? 'error-header-enable' : 'form-title'" xs2>
            {{ memberProfileConstants.CONTACT_INFORMATION.PRIMARY_NUMBER_FOR_MY_YPO_ACCOUNT }}
          </v-flex>
        </v-layout>
        <v-flex class="phone-numbers-edit__block">
          <v-layout row wrap>
            <v-flex class="edit-label" xs1>
              <v-flex :class="isBusinessErrorLabel ? 'error-label-enable' : 'error-label-disable'" tag="span">
                {{ memberProfileConstants.CONTACT_INFORMATION.BUSINESS }}{{ memberProfileConstants.COLON }}
              </v-flex>
            </v-flex>
            <v-flex xs5>
              <v-flex class="form-control">
                <ypo-phone-number :country-code="modelPhoneNumber.countryCode"
                                :extension="modelPhoneNumber.businessPhoneExt"
                                :phone="modelPhoneNumber.businessPhone"
                                :show-extension="true"
                                @update="updatedBusinessPhone"
                />
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-flex class="form-control">
                <v-checkbox
                    v-model="modelPhoneNumber.businessPhoneOnProfile"
                    :disabled="modelPhoneNumber.disableForBusinessPhone"
                    class="box"
                    color="ypo_blue"
                    data-qe-id="phone_is-on-profile_checkbox"
                    @change="enableDoneButton()"></v-checkbox>
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-flex class="form-control">
                <v-checkbox
                    v-model="modelPhoneNumber.textMsgonBusinessPhone"
                    :disabled="modelPhoneNumber.disableForBusinessPhone"
                    class="box"
                    color="ypo_blue"
                    data-qe-id="phone_business_can-text_checkbox"
                    v-on:change="enableDoneButton()"></v-checkbox>
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-radio-group v-model="modelPhoneNumber.preferredPhone" text-xs-center>
                <v-flex class="form-control">
                  <v-radio
                      :disabled="modelPhoneNumber.disableForBusinessPhone"
                      :value="memberProfileConstants.CONTACT_INFORMATION.IS_BUSINESS_PRIMARY_NUMBER"
                      class="radio-item"
                      color="ypo_blue"
                      data-qe-id="phone_primary_business_radio-btn"
                      v-on:change="primaryNumberForYPOAccount($event)">
                  </v-radio>
                </v-flex>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex class="edit-label" xs1>
              <v-flex :class="isHomeErrorLabel ? 'error-label-enable' : 'error-label-disable'" tag="span">
                {{ memberProfileConstants.HOME }}{{ memberProfileConstants.COLON }}
              </v-flex>
            </v-flex>
            <v-flex xs5>
              <v-flex class="form-control">
                <ypo-phone-number :country-code="modelPhoneNumber.homePhoneCountryCode"
                                :phone="modelPhoneNumber.homePhone"
                                @update="updateHomePhone"
                />
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-flex class="form-control">
                <v-checkbox
                    v-model="modelPhoneNumber.homePhoneOnProfile"
                    :disabled="modelPhoneNumber.disableForHomePhone"
                    class="box"
                    color="ypo_blue"
                    data-qe-id="phone_home_is-on-profile_checkbox"
                    v-on:change="enableDoneButton()"></v-checkbox>
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-flex class="form-control">
                <v-checkbox
                    v-model="modelPhoneNumber.textMsgonHomePhone"
                    :disabled="modelPhoneNumber.disableForHomePhone"
                    class="box"
                    color="ypo_blue"
                    data-qe-id="phone_home_can-text_checkbox"
                    v-on:change="enableDoneButton()"></v-checkbox>
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-radio-group v-model="modelPhoneNumber.preferredPhone" text-xs-center>
                <v-flex class="form-control">
                  <v-radio
                      :disabled="modelPhoneNumber.disableForHomePhone"
                      :value="memberProfileConstants.CONTACT_INFORMATION.IS_HOME_PRIMARY_NUMBER"
                      class="radio-item"
                      color="ypo_blue"
                      data-qe-id="phone_primary_home_radio-btn"
                      v-on:change="primaryNumberForYPOAccount($event)"></v-radio>
                </v-flex>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex class="edit-label" xs1>
              <v-flex :class="isMobileErrorLabel ? 'error-label-enable' : 'error-label-disable'" tag="span">
                {{ memberProfileConstants.CONTACT_INFORMATION.MOBILE }}{{ memberProfileConstants.COLON }}
              </v-flex>
            </v-flex>
            <v-flex xs5>
              <v-flex class="form-control">
                <ypo-phone-number :country-code="modelPhoneNumber.mobilePhoneCountryCode"
                                :phone="modelPhoneNumber.mobilePhone"
                                @update="updateMobilePhone"
                />
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-flex class="form-control">
                <v-checkbox
                    v-model="modelPhoneNumber.mobilePhoneOnProfile"
                    :disabled="modelPhoneNumber.disableForMobilePhone"
                    class="box"
                    color="ypo_blue"
                    data-qe-id="phone_mobile_is-on-profile_checkbox"
                    v-on:change="enableDoneButton()"></v-checkbox>
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-flex class="form-control">
                <v-checkbox
                    v-model="modelPhoneNumber.textMsgonMobilePhone"
                    :disabled="modelPhoneNumber.disableForMobilePhone"
                    class="box"
                    color="ypo_blue"
                    data-qe-id="phone_mobile_can-text_checkbox"
                    v-on:change="enableDoneButton()"></v-checkbox>
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-radio-group v-model="modelPhoneNumber.preferredPhone" text-xs-center>
                <v-flex class="form-control">
                  <v-radio
                      :disabled="modelPhoneNumber.disableForMobilePhone"
                      :value="memberProfileConstants.CONTACT_INFORMATION.IS_MOBILE_PRIMARY_NUMBER"
                      class="radio-item"
                      color="ypo_blue"
                      data-qe-id="phone_primary_mobile_radio-btn"
                      v-on:change="primaryNumberForYPOAccount($event)"></v-radio>
                </v-flex>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex class="edit-label" xs1>
              <v-flex :class="isOtherErrorLabel ? 'error-label-enable' : 'error-label-disable'" tag="span">
                {{ memberProfileConstants.OTHER }}{{ memberProfileConstants.COLON }}
              </v-flex>
            </v-flex>
            <v-flex xs5>
              <v-flex class="form-control">
                <ypo-phone-number :country-code="modelPhoneNumber.otherPhoneCountryCode"
                                :phone="modelPhoneNumber.otherPhone"
                                @update="updateOtherPhone"
                />
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-flex class="form-control">
                <v-checkbox
                    v-model="modelPhoneNumber.otherPhoneOnProfile"
                    :disabled="modelPhoneNumber.disableForOtherPhone"
                    class="box"
                    color="ypo_blue"
                    data-qe-id="phone_other-phone_is-on-profile_checkbox"
                    v-on:change="enableDoneButton()"></v-checkbox>
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-flex class="form-control">
                <v-checkbox
                    v-model="modelPhoneNumber.textMsgonOtherPhone"
                    :disabled="modelPhoneNumber.disableForOtherPhone"
                    class="box"
                    color="ypo_blue"
                    data-qe-id="phone_other-phone_can-text_checkbox"
                    v-on:change="enableDoneButton()"></v-checkbox>
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-radio-group v-model="modelPhoneNumber.preferredPhone" text-xs-center>
                <v-flex class="form-control">
                  <v-radio
                      :disabled="modelPhoneNumber.disableForOtherPhone"
                      :value="memberProfileConstants.CONTACT_INFORMATION.IS_OTHER_PRIMARY_NUMBER"
                      class="radio-item"
                      color="ypo_blue"
                      data-qe-id="phone_primary_other_radio-btn"
                      v-on:change="primaryNumberForYPOAccount($event)"></v-radio>
                </v-flex>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex class="edit-label" xs1>
              <v-flex :class="isWhatsAppErrorLabel ? 'error-label-enable' : 'error-label-disable'" tag="span">
                {{ memberProfileConstants.WHATSAPP }}{{ memberProfileConstants.COLON }}
              </v-flex>
            </v-flex>
            <v-flex xs5>
              <v-flex class="form-control">
                <ypo-phone-number :country-code="modelPhoneNumber.whatsAppCode"
                                :phone="modelPhoneNumber.whatsAppPhone"
                                @update="updateWhatsAppPhone"
                />
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-flex class="form-control">
                <v-checkbox
                    v-model="whatsAppDefaultValue"
                    :disabled="true"
                    class="box"
                    color="ypo_blue"
                    data-qe-id="phone_whatsapp-phone_is-on-profile_checkbox"></v-checkbox>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex class="edit-label" xs1>
              <v-flex :class="isBusinessFaxErrorLabel ? 'error-label-enable' : 'error-label-disable'" tag="span">
                {{ memberProfileConstants.CONTACT_INFORMATION.BUSINESS_FAX }}{{ memberProfileConstants.COLON }}
              </v-flex>
            </v-flex>
            <v-flex xs5>
              <v-flex class="form-control">
                <ypo-phone-number :country-code="modelPhoneNumber.faxCountryCode"
                                :phone="modelPhoneNumber.fax"
                                @update="updateBusinessFax"
                />
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-flex class="form-control">
                <v-checkbox
                    v-model="faxDefaultValue"
                    :disabled="true"
                    class="box"
                    color="ypo_blue"
                    data-qe-id="phone_fax_default_checkbox"></v-checkbox>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex class="edit-label" xs1>
              <v-flex :class="isHomeFaxErrorLabel ? 'error-label-enable' : 'error-label-disable'" tag="span">
                {{ memberProfileConstants.CONTACT_INFORMATION.HOME_FAX }}{{ memberProfileConstants.COLON }}
              </v-flex>
            </v-flex>
            <v-flex xs5>
              <v-flex class="form-control">
                <ypo-phone-number :country-code="modelPhoneNumber.homeFaxCountryCode"
                                :phone="modelPhoneNumber.homeFax"
                                @update="updateHomeFax"
                />
              </v-flex>
            </v-flex>
            <v-flex xs2>
              <v-flex class="form-control">
                <v-checkbox
                    v-model="faxDefaultValue"
                    :disabled="true"
                    class="box"
                    color="ypo_blue"
                    data-qe-id="phone_home-fax_default_checkbox"></v-checkbox>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-form>
    </v-card-text>
    <status-bar :action="savePhoneNumberAction"></status-bar>
    <div
        v-if="showGlobalErrorMessage"
        class="bottom-error-label text-center">
      {{ memberProfileConstants.CONTACT_INFORMATION.PLS_COMPLETE_REQUIRED_FIELDS }}
    </div>
    <v-card-actions>
      <v-flex pa-3 text-xs-right>
        <v-btn class="primary_btn transparent" data-qe-id="cancel_dialog_btn" flat @click="cancel(false)">
          {{ appCommonConstants.CANCEL }}
        </v-btn>
        <v-btn :disabled="!valid || showGlobalErrorMessage" class="primary_btn" data-qe-id="save_dialog_btn"
               @click="savePhoneNumber()">
          {{ appCommonConstants.DONE }}
        </v-btn>
      </v-flex>
    </v-card-actions>
  </v-card>
</template>

<script>
import { assetSummaryConstants, memberProfileConstants } from "../memberProfile.constants.js";
import { mapState, mapActions } from "vuex";
import { storeAction } from "../../../store/storeActions.constant";
import StatusBar from "../../StatusBar/StatusBar";
import { appCommonConstants } from "../../appCommon.constants.js";
import { onlyNumber } from "@/common/utils/utils.js";
import { gtmEventName } from "@/plugins/gtmAnalytics";
import { gaDataLayerEvent } from "@/plugins/analytics";
import VuePhoneNumberInput from 'vue-phone-number-input';
import { getCountryFromCallingCode } from "@/common/utils/phoneUtils";
import YpoPhoneNumber from "@/components/YpoPhoneNumber/YpoPhoneNumber.vue";

export default {
  name: "PhoneNumbersDialog",
  data: () => ({
    isYPOPrimaryErrorMessage: false,
    isBusinessErrorLabel: false,
    isMobileErrorLabel: false,
    isHomeErrorLabel: false,
    isOtherErrorLabel: false,
    isBusinessFaxErrorLabel: false,
    isHomeFaxErrorLabel: false,
    isWhatsAppErrorLabel: false,
    isNumber: false,
    onlyNumber,
    valid: false,
    isSave: true,
    faxDefaultValue: true,
    memberProfileConstants,
    appCommonConstants,
    assetSummaryConstants,
    whatsAppDefaultValue: true,
    newPhone: '',
    getCountryFromCallingCode,
  }),
  components: {
    YpoPhoneNumber,
    StatusBar,
    VuePhoneNumberInput,
  },
  props: {
    phoneNumbersDialog: {
      type: Boolean,
    },
    modelPhoneNumber: {
      type: Object,
      required: false,
    },
  },
  methods: {
    ...mapActions({
      savePhoneInformation: `memberProfile/${storeAction.savePhoneInformation}`,
    }),
    primaryNumberForYPOAccount(value, makeEmpty) {
      if (makeEmpty) {
        if (this.modelPhoneNumber.preferredPhone === value) {
          this.isNumber = false;
          this.modelPhoneNumber.preferredPhone = null;
          this.isYPOPrimaryErrorMessage = true;
        }
      } else {
        this.modelPhoneNumber.preferredPhone = value;
        this.isYPOPrimaryErrorMessage = false;
        this.enableDoneButton();
      }
    },
    savePhoneNumber() {
      const memberID = this.modelPhoneNumber.currentUserID;
      this.modelPhoneNumber.Id = memberID;
      this.savePhoneInformation(this.modelPhoneNumber)
          .then(() => {
            this.$emit('click', false);
            this.scrollTop();
            gaDataLayerEvent(gtmEventName.C_Profile_Edit, `Phone - ${memberID}${this.isRedirectFromConnectPlus ? ' | Connect+ Redirect' : ''}`);
          });
    },
    cancel(value) {
      this.isSave = true;
      this.$emit('click', value);
      this.scrollTop();
    },
    scrollTop() {
      this.$refs.phoneNumbersDailogid.scrollTop = 0;
    },
    enableDoneButton() {
      this.isNumber = true;
    },
    autoEnableRadionButtionWhenCountIsOne() {
      if (this.modelPhoneNumber.disableForBusinessPhone && this.modelPhoneNumber.disableForHomePhone && this.modelPhoneNumber.disableForMobilePhone && this.modelPhoneNumber.disableForOtherPhone) {
        this.modelPhoneNumber.preferredPhone = null;
        this.isYPOPrimaryErrorMessage = false;
        this.enableDoneButton();
      } else {
        if (this.modelPhoneNumber.disableForHomePhone && this.modelPhoneNumber.disableForMobilePhone && this.modelPhoneNumber.disableForOtherPhone) {
          this.modelPhoneNumber.preferredPhone = memberProfileConstants.CONTACT_INFORMATION.IS_BUSINESS_PRIMARY_NUMBER;
          this.isYPOPrimaryErrorMessage = false;
          this.enableDoneButton();
        }
        if (this.modelPhoneNumber.disableForBusinessPhone && this.modelPhoneNumber.disableForMobilePhone && this.modelPhoneNumber.disableForOtherPhone) {
          this.modelPhoneNumber.preferredPhone = memberProfileConstants.CONTACT_INFORMATION.IS_HOME_PRIMARY_NUMBER;
          this.isYPOPrimaryErrorMessage = false;
          this.enableDoneButton();
        }
        if (this.modelPhoneNumber.disableForBusinessPhone && this.modelPhoneNumber.disableForHomePhone && this.modelPhoneNumber.disableForOtherPhone) {
          this.modelPhoneNumber.preferredPhone = memberProfileConstants.CONTACT_INFORMATION.IS_MOBILE_PRIMARY_NUMBER;
          this.isYPOPrimaryErrorMessage = false;
          this.enableDoneButton();
        }
        if (this.modelPhoneNumber.disableForBusinessPhone && this.modelPhoneNumber.disableForHomePhone && this.modelPhoneNumber.disableForMobilePhone) {
          this.modelPhoneNumber.preferredPhone = memberProfileConstants.CONTACT_INFORMATION.IS_OTHER_PRIMARY_NUMBER;
          this.isYPOPrimaryErrorMessage = false;
          this.enableDoneButton();
        }
      }
    },
    updatedBusinessPhone(data) {
      this.modelPhoneNumber.businessPhone = data.phone;
      this.modelPhoneNumber.countryCode = data.countryCode;
      this.modelPhoneNumber.businessPhoneExt = data.extension;
      this.isBusinessErrorLabel = data.isInvalid;
      this.modelPhoneNumber.businessPhoneOnProfile = true;
      this.modelPhoneNumber.disableForBusinessPhone = false;
      if (!this.modelPhoneNumber.businessPhone.length) {
        this.modelPhoneNumber.businessPhoneOnProfile = false;
        this.modelPhoneNumber.textMsgonBusinessPhone = false;
        this.modelPhoneNumber.disableForBusinessPhone = true;
        this.primaryNumberForYPOAccount(memberProfileConstants.CONTACT_INFORMATION.IS_BUSINESS_PRIMARY_NUMBER, true);
      }
      this.autoEnableRadionButtionWhenCountIsOne();
    },
    updateHomePhone(data) {
      this.modelPhoneNumber.homePhone = data.phone;
      this.modelPhoneNumber.homePhoneCountryCode = data.countryCode;
      this.isHomeErrorLabel = data.isInvalid;
      this.modelPhoneNumber.homePhoneOnProfile = true;
      this.modelPhoneNumber.disableForHomePhone = false;
      if (!this.modelPhoneNumber.homePhone.length) {
        this.modelPhoneNumber.homePhoneOnProfile = false;
        this.modelPhoneNumber.textMsgonHomePhone = false;
        this.modelPhoneNumber.disableForHomePhone = true;
        this.primaryNumberForYPOAccount(memberProfileConstants.CONTACT_INFORMATION.IS_HOME_PRIMARY_NUMBER, true);
      }
      this.autoEnableRadionButtionWhenCountIsOne();
    },
    updateMobilePhone(data) {
      this.modelPhoneNumber.mobilePhone = data.phone;
      this.modelPhoneNumber.mobilePhoneCountryCode = data.countryCode;
      this.isMobileErrorLabel = data.isInvalid;
      this.modelPhoneNumber.mobilePhoneOnProfile = true;
      this.modelPhoneNumber.textMsgonMobilePhone = true;
      this.modelPhoneNumber.disableForMobilePhone = false;
      if (!this.modelPhoneNumber.mobilePhone.length) {
        this.modelPhoneNumber.mobilePhoneOnProfile = false;
        this.modelPhoneNumber.textMsgonMobilePhone = false;
        this.modelPhoneNumber.disableForMobilePhone = true;
        this.primaryNumberForYPOAccount(memberProfileConstants.CONTACT_INFORMATION.IS_MOBILE_PRIMARY_NUMBER, true);
      }
      this.autoEnableRadionButtionWhenCountIsOne();
    },
    updateOtherPhone(data) {
      this.modelPhoneNumber.otherPhone = data.phone;
      this.modelPhoneNumber.otherPhoneCountryCode = data.countryCode;
      this.isOtherErrorLabel = data.isInvalid;
      this.modelPhoneNumber.otherPhoneOnProfile = true;
      this.modelPhoneNumber.disableForOtherPhone = false;
      if (!this.modelPhoneNumber.otherPhone.length) {
        this.modelPhoneNumber.otherPhoneOnProfile = false;
        this.modelPhoneNumber.textMsgonOtherPhone = false;
        this.modelPhoneNumber.disableForOtherPhone = true;
        this.primaryNumberForYPOAccount(memberProfileConstants.CONTACT_INFORMATION.IS_OTHER_PRIMARY_NUMBER, true);
      }
      this.autoEnableRadionButtionWhenCountIsOne();
    },
    updateWhatsAppPhone(data) {
      this.modelPhoneNumber.whatsAppPhone = data.phone;
      this.modelPhoneNumber.whatsAppCode = data.countryCode;
      this.isWhatsAppErrorLabel = data.isInvalid;
      this.modelPhoneNumber.whatsAppOnProfile = true;
      this.modelPhoneNumber.disableForWhatsAppPhone = false;
      if (!this.modelPhoneNumber.whatsAppPhone.length) {
        this.modelPhoneNumber.whatsAppOnProfile = false;
        this.modelPhoneNumber.whatsAppTextMessage = false;
        this.modelPhoneNumber.disableForWhatsAppPhone = true;
        this.primaryNumberForYPOAccount(memberProfileConstants.CONTACT_INFORMATION.IS_WHATSAPP_PRIMARY_NUMBER, true);
      }
      this.autoEnableRadionButtionWhenCountIsOne();
    },
    updateBusinessFax(data) {
      this.modelPhoneNumber.fax = data.phone;
      this.modelPhoneNumber.faxCountryCode = data.countryCode;
      this.isBusinessFaxErrorLabel = data.isInvalid;
      this.autoEnableRadionButtionWhenCountIsOne();
    },
    updateHomeFax(data) {
      this.modelPhoneNumber.homeFax = data.phone;
      this.modelPhoneNumber.homeFaxCountryCode = data.countryCode;
      this.isHomeFaxErrorLabel = data.isInvalid;
      this.autoEnableRadionButtionWhenCountIsOne();
    },
  },
  computed: {
    ...mapState("actionState", ["actions"]),
    savePhoneNumberAction() {
      return this.actions[storeAction.savePhoneInformation];
    },
    showGlobalErrorMessage() {
      if (this.isBusinessErrorLabel || this.isHomeErrorLabel || this.isMobileErrorLabel || this.isOtherErrorLabel || this.isWhatsAppErrorLabel || this.isBusinessFaxErrorLabel || this.isHomeFaxErrorLabel || this.isYPOPrimaryErrorMessage) {
        return true;
      }
      return false;
    },
    isRedirectFromConnectPlus() {
      return this.$route && this.$route.query
          && this.$route.query.connectPlusRedirect && this.$route.query.connectPlusRedirect === 'true';
    },
  },
};
</script>

<style lang="scss">
@import "../../../common/styles/_colors.scss";

.phone-numbers-edit {
  &__block {
    position: relative;

    > .layout {
      min-height: 30px;
      align-items: center;
      padding: 5px;

      &:nth-child(2n+1) {
        background: $ypo-extra-light-gray;
      }
    }

    .form-control {
      min-height: inherit !important;

      .vue-tel-input {
        box-shadow: none !important;
        border: 0;
        border-bottom: 1px solid rgba($black, 0.5);
        border-radius: 0;

        .dropdown {
          padding: 7px 0;

          .iti-flag {
            margin-left: 1px;
          }

          .country-code {
            font-size: 14px;
            font-weight: 600;
          }
        }
      }
    }

    .v-radio.radio-item {
      margin-bottom: 37px;
      top: 3px;
      position: relative;
      left: 10px;
    }

    .v-input--checkbox {
      position: relative;
      top: 5px;
      left: 10px;
    }

    .v-text-field {
      padding-top: 0;
      margin-top: 0;
    }

    .v-input--radio-group__input {
      position: absolute;
      top: 0;
    }

    .v-input--radio-group {
      margin-top: -5px !important;
    }

    .v-input input {
      font-size: 12px;
    }

    .edit-label {
      font-weight: 600;
      text-align: left;
      font-size: 13px;

      > span {
        position: relative;
        top: 8px;
      }
    }

    .extension-number {
      margin-top: 20px;
    }
  }

  .form-title {
    font-size: 13px;
    color: $ypo-blue;
    font-weight: 600;
    line-height: normal;
  }

  .error-header-enable {
    font-size: 14px;
    color: $ypo-red;
    font-weight: 600;
    line-height: normal;
  }

  .v-text-field__details {
    overflow: visible;
  }

  .v-messages__message {
    white-space: nowrap;
    position: absolute;
    overflow: visible;
    z-index: 1;
    font-size: 11px;
  }

  .bottom-error-label {
    margin: 13px 0 0 0;
    color: $ypo-red;
    z-index: 1;
    font-size: 14px;
  }
}
</style>
